






















































































































































// eslint-disable-next-line class-methods-use-this
/* eslint-disable @typescript-eslint/camelcase */
// eslint-disable-next-line no-constant-condition
import { ValidationObserver } from 'vee-validate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ExportIcon from 'mdi-vue/FileExportOutline';
import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import AddIcon from 'mdi-vue/Plus';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { PriceTier } from '@/libs/api.interfaces';
import BillingFields from '../components/BillingFields.vue';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    AddIcon,
    Checkbox,
    Loader,
    Button,
    ExportIcon,
    SearchField,
    SearchRow,
    Select,
    Modal,
    FormInput,
    BillingFields,

  },
})

export default class PaymentChannel extends Vue {
  @Prop(String) channelId!: string;
  @Prop(String) merchantCode!: string;
  @Prop(String) credential!: string;
  @Prop(String) title!: string;
  @Prop(Boolean) button!: boolean;

  billingTypes = [
    { label: 'Normal', value: 'normal' },
    { label: 'MDR', value: 'mdr' },
    { label: 'Tiering per Traffic', value: 'tiring' },
    { label: 'Tiering per Amount', value: 'tiring_amount' },
  ];

  BussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  billing: BillingFieldsModel = {
    bussinessType: '',
    transactionFeeType: { label: 'Normal', value: 'normal' },
    transactionFeeValue: '',
    feeBank: '',
    includePPN: false,
    bussinessModel: { label: 'Direct Bundling', value: '0' },
    description: '',
    live: false,
  }

  serviceName = '';
  merchant_code = '';

  channelProdNull = true;

  close() {
    this.$emit('modal', false);
  }

  mounted() {
    console.log(this.channelId, this.credential);
    this.getPricing();
  }

  async getPricing() {
    try {
      // eslint-disable-next-line max-len
      const { data } = await api.get(`consumer/channel/edit?credentials=${this.credential}&channel_id=${this.channelId}&merchant_code=${this.merchantCode}`);
      if (!Array.isArray(data)) {
        const type = data.billType || 'normal';
        this.channelProdNull = data.length === 0;
        this.serviceName = data.service;
        this.merchantCode = data.merchant_code;
        this.billing = {
          bussinessType: data.business_type,
          transactionFeeType: this.billingTypes.find((e) => e.value === type) || { label: 'Normal', value: 'normal' },
          feeBank: data.fee_bank ? data.fee_bank : 0,
          includePPN: data.ppn === 1,
          // eslint-disable-next-line max-len
          bussinessModel: this.BussinessModels.find((e) => e.value === data.business_model.toString()) || { label: 'Direct Bundling', value: '0' },
          description: data.descp,
          transactionFeeValue: type === 'normal' || type === 'mdr'
            ? (data.price as string) : (data.price as PriceTier[]).map((e) => ({
              min: e.traffic_min.toString() || '0',
              max: e.traffic.toString() || '0',
              price: e.price.toString() || '0',
              type: e.type || '',
            })),
          live: data.status !== '0',
        };
      }
    } catch (error) {
      console.log(error);
    }
  }

  async updatePricing() {
    try {
      let feeValue;
      if (this.billing.transactionFeeType.value === 'tiring'
        || this.billing.transactionFeeType.value === 'tiring_amount') {
        feeValue = (this.billing.transactionFeeValue as Tier[]).map((e) => ({
          traffic_min: e.min,
          traffic: e.max,
          price: e.price,
          type: e.type,
        }));
      } else {
        feeValue = this.billing.transactionFeeValue;
      }

      await api.post('consumer/channel/edit', {
        merchant_code: this.merchantCode,
        service_name: this.serviceName,
        credential: this.credential,
        bill_type: this.billing.transactionFeeType.value,
        price: feeValue,
        fee_bank: this.billing.feeBank,
        ppn: this.billing.includePPN ? '1' : '0',
        descp: this.billing.description,
        business_type: this.billing.bussinessType,
        // eslint-disable-next-line max-len
        billing_data: JSON.stringify([{ type: this.billing.transactionFeeType.value, price: this.billing.transactionFeeValue }]),
        // eslint-disable-next-line max-len
        transaction_type: JSON.stringify(['auth', 'sale', 'void', 'refund', 'auth_declined', 'sale_declined', 'auth_filtered', 'sale_filtered']),
        business_model: this.billing.bussinessModel.value,
      });
      showToast(ToastType.SUCCESS, 'Success Update Pricing', 'Congrats, your changes have been saved');
      this.close();
    } catch (error) {
      showToast(ToastType.FAILED, 'Oops… Sorry', error.response.data);
    }
  }
}
